export const PRODUCT_SELECTED = "PRODUCT_SELECTED";
